module.exports = {
	"(all_markup_percentsign_will_base_on_this_price)": "（所有加成 % 将会基于此价格）",
	"(mm_unit)": "(规格单位)",
	"(inches)": "(英寸)",
	"(no_sale_will_be_allowed_lower_than_this_price)": "（销售不得低于此价格）",
	"(num)": "(数量)",
	"(pkg_type)": "(包装类型)",
	"(pkg_size)": "(包装尺寸)",
	"(pkg_size_1)": "(包装尺寸 1)",
	"(pkg_size_2)": "(包装尺寸 2)",
	"(ref_no)": "(参考编号)",
	")__action_denied_": "）。动作已取消。",
	"00_dashsign_07_days": "00 - 07 天",
	"08_dashsign_30_days": "08 - 30 天",
	"00_dashsign_30_days": "00 - 30 天",
	"31_dashsign_60_days": "31 - 60 天",
	"4_wks_sale": "4周销售",
	"61_dashsign_90_days": "61 - 90 天",
	"91_plussign_days": "91+ 天",
	"account": "账号",
	"account_payable": "应付帐款",
	"account_payable_payment_report": "应付帐款（付款报表）",
	"account_payment_term": "帐户付款方式",
	"account_receivable": "应收帐款",
	"account_receivable_receive_report": "应收帐款（收款报表）",
	"action": "行动",
	"action_log": "修改记录",
	"active": "启用",
	"active_customer": "启用客户",
	"active_schedule": "",
	"active_vendor": "可用供货商",
	"add": "新增",
	"add_a_new_category": "新增类别",
	"add_a_new_group": "新增组别",
	"add_a_new_payment_term": "新增付款条款",
	"add_agent": "新增代理",
	"add_another_product": "新增商品",
	"add_customer": "新增客户",
	"add_invoice": "新增发票",
	"add_new_bin": "新增储位",
	"add_new_favorite": "新增收藏",
	"add_new_route": "新增线路",
	"add_new_zone": "新增区域",
	"add_non_product": "新增非商品",
	"add_payment_term": "新增付款条款",
	"add_pickup": "",
	"add_purchase_order": "新增采购单",
	"add_shipping_address": "",
	"add_vendor": "新增供货商",
	"address": "地址",
	"adjust": "调整",
	"adjust_some_or_all_of_the_selected_inventory": "调整部分或全部选定库存",
	"adjustment": "调整",
	"adjustment_date": "调整日期",
	"adjustment_quantity": "调整量",
	"admin_tools": "管理工具",
	"advanced_search": "进阶搜索",
	"afg_choice": "AFG Choice",
	"agent_information": "代理信息",
	"agent_name": "代理名称",
	"agent_num": "代理商编号",
	"agents": "代理商",
	"all": "所有",
	"all_bins": "所有储位",
	"all_products": "所有商品",
	"alt_phone": "替代号码",
	"amount": "量",
	"approve": "批准",
	"ap_aged_report": "应付帐龄分析表",
	"ap_aged_report_detail": "应付帐龄分析表细节",
	"ap_num": "AP 编号",
	"ap_records_existed_for_this_warehouse_receive_(apnum:_": "此收货单已有应付纪录（AP 编号：",
	"ap_statistics": "应付帐款数据",
	"ar_aged_report": "应收帐龄分析表",
	"ar_aged_report_detail": "应收帐龄分析表细节",
	"ar_customer_payment": "应收客户款项",
	"ar_date": "AR 日期",
	"ar_num": "AR 编号",
	"ar_slashsign_ap": "帐款管理",
	"ar_statistics": "应收帐款数据",
	"arrival": "到达",
	"arrival_status": "到达状态",
	"attachment_upload": "上传附件",
	"auto_apply": "Auto Apply",
	"auto_fill": "自动填入",
	"auto_load": "自动加载",
	"auto_putaway": "自动入库",
	"available": "可用",
	"available_bins": "可用储位",
	"avg_cost": "平均库存价",
	"avg_in_stock_dollarsign": "平均库存价",
	"avg_markup_percentsign": "平均加成 %",
	"avg_sale_dollarsign": "平均销售价",
	"b2b_b2c": "B2B/B2C",
	"back": "返回",
	"balance": "馀额",
	"barcode": "条形码",
	"barcode_poundsign": "条形码 #",
	"basic_info": "基本信息",
	"batch_no": "批次号",
	"batch_no_po_no": "批次编号 (采购单编号)",
	"batch_num": "批次编号",
	"bill_date": "付款日期",
	"billing_address": "付款地址",
	"billing_contact": "付款联系人",
	"billing_details": "付款明细",
	"billing_information": "付款信息",
	"bin": "储位",
	"bin_amount": "储位数量",
	"bin_detail_view": "检视储位细节",
	"bin_name": "储位名称",
	"bin_range": "储位范围",
	"bins_available": "可用储位",
	"button": "Button",
	"buy": "Buy",
	"buy_a_get_b": "Buy A Get B",
	"by_3_days": "3 天",
	"by_po": "按采购单",
	"by_product": "按商品",
	"by_quantity": "By Quantity",
	"by_quantity_discount": "按数量 (折扣)",
	"by_quantity_product": "按数量 (商品)",
	"by_total_price": "按总价 ",
	"by_unit": "按单位",
	"by_week": "按周",
	"by_weight": "按重量",
	"cancel": "取消",
	"cancel_return": "取消退还",
	"cancelled": "取消",
	"carry_type": "运输规格",
	"carrier": "承运人",
	"carrier_code": "承运人号码",
	"change_carrier_info": "承运人讯息",
	"bol_num": "BOL 号码",
	"pro_num": "PRO 号码",
	"ltl_carrier": "零擔貨運运营商",
	"please_clarify_other": "请输入其他方式",
	"carry_type_shipping_method": "运输规格和方式",
	"case (large prod)": "大货",
	"case": "箱",
	"cash_dollarsign": "现金$",
	"category": "类别",
	"category_1": "商品类别1",
	"category_2": "商品类别2",
	"category_2_product_list": "商品类别2 商品列表",
	"category_2_B2B_product_list": "商品类别2 B2B 商品列表",
	"category_2_b2c": "商品类别2 B2C",
	"category_2_b2b": "商品类别2 B2B",
	"category_analysis": "类编分析",
	"category_detail": "类别细节",
	"category_name": "类别名称",
	"category_hidden": "隐藏类别",
	"category_visible": "显示类别",
	"cc_hold_until": "卡片预扣费用至",
	"change_delivery_fee": "改变送货费用",
	"change_employee_note": "改变员工备注",
	"change_payment_method": "改变付款方式",
	"change_pull_sheet": "Pull Sheet Assign Amount",
	"change_ship_weight": "改变运输重量",
	"change_weight_button": "改变重量",
	"change_discount_rates": "改变打折量",
	"charged": "已扣款",
	"check": "支票",
	"check_dollarsign": "支票$",
	"check_num": "支票号码",
	"chinese": "中文",
	"chowbus": "Chowbus",
	"chowbus_import": "Chowbus 导入",
	"cif": "到库价",
	"city": "城市",
	"city_report": "城市报表",
	"clear": "清除",
	"clear_all_values": "清空数据",
	"close": "关闭",
	"COD": "COD",
	"code": "Code",
	"company": "公司",
	"complete": "完成",
	"complete_return": "完成退货",
	"complete_this_sheet": "完成此表",
	"completed": "完成",
	"confirm": "确认",
	"confirm_action": "确认操作",
	"confirm_add": "确认新增",
	"confirm_create": "确认新增",
	"confirm_delete": "确认删除",
	"confirm_group_change": "确认组别修改",
	"confirm_new_password": "确认新密码",
	"confirm_password": "确认密码",
	"confirm_print_tracking": "确认打印标签",
	"confirm_void": "确定作废",
	"confirmation": "确认",
	"contact": "联系人",
	"contact_information": "联系信息",
	"contact_person": "联系人",
	"content_management": "内容管理",
	"continue_product": "解锁商品",
	"convert": "转换",
	"convert_date": "转换日期",
	"convert_item_price": "转换商品价格",
	"convert_prod_qty": "转换数量",
	"convert_product_qty": "转换商品数量",
	"convert_quantity": "转换数量",
	"convert_target_quantity": "转换的目标数量",
	"convert_type": "转换类型",
	"convert_user": "转换用户",
	"convertable_product": "可转换商品",
	"cost": "成本",
	"costs_details": "成本细节",
	"county": "县",
	"create": "创建",
	"create_a_new_agent": "创建新代理",
	"create_a_new_category": "创建类别",
	"create_a_new_customer": "创建客户",
	"create_a_new_favorite": "创建收藏",
	"create_a_new_product": "创建商品",
	"create_a_new_purchase": "创建采购单",
	"create_a_new_purchase_order": "创建一个新的采购订单",
	"create_a_new_purchase_quote": "创建采购报价单",
	"create_a_new_purchase_return": "创建供货商",
	"create_a_new_purchase_schedule": "创建采购时间表",
	"create_a_new_purchase_template": "创建采购模板",
	"create_a_new_sales_order": "创建销售订单",
	"create_a_new_user": "新建用户",
	"create_a_new_vendor": "创建供货商",
	"create_a_purchase_quote": "创建采购报价",
	"create_a_purchase_schedule": "创建采购计划",
	"create_account": "",
	"create_and_duplicate": "创建和复制",
	"create_bin": "创建储位",
	"create_customer_return": "创建客户退货",
	"create_date": "创建日期",
	"create_inventory_adjustment_sheet": "创建库存调整列表",
	"create_inventory_convert_sheet": "创建库存转换列表",
	"create_inventory_relocation_sheet": "创建搬迁记录表",
	"create_inventory_repackage_sheet": "创建库存重新包装表",
	"create_new_po": "创建新的采购单",
	"create_new_purchase_order": "创建采购单",
	"create_new_sales_order": "创建新销售单",
	"create_payment": "创建付款",
	"create_product": "创建商品",
	"create_promotion": "创建促销",
	"create_purchase_order": "",
	"create_purchase_quote": "创建采购报价",
	"create_put_away": "",
	"create_receiving": "创建收货",
	"create_role": "创建角色",
	"create_sales_order": "创建一个新的销售单",
	"create_sales_return": "创建销售退货",
	"create_so": "新建销售单",
	"create_task": "创建任务",
	"create_time": "创建时间",
	"create_user": "创建用户",
	"create_warehouse": "创建仓库",
	"create_zone": "",
	"created": "创建",
	"created_by": "创建",
	"created_time": "创建时间",
	"credit": "积分",
	"credit_card": "信用卡",
	"Credit_card": "信用卡：",
	"credit_card_dollarsign": "信用卡$",
	"credit_limit": "信用额度",
	"credit_limit_payment_term_warning": "用户已超过信用或者结账周期限制， 请输入PASSCODE确认身份再继续",
	"credit_line": "信用额度",
	"credit_note": "客户信用记录",
	"credit_reason": "信用理由",
	"credit_status": "信用",
	"CRV": "CRV",
	"crv": "CRV",
	"currency_management": "货币管理",
	"current_bin": "当前储位",
	"current_inventory": "当前库存",
	"current_order_amount": "当前订单数量",
	"current_order_total": "目前的订单总额",
	"current_quantity": "当前数量",
	"current_target_inventory": "当前的目标库存",
	"current_zone": "当前区域",
	"cust_id": "客户ID",
	"cust_name": "客户名称",
	"cust_no": "客户No",
	"cust_po": "客户PO.",
	"customer": "顾客",
	"customer_group": "Customer Group",
	"customer_credit": "客户信用",
	"customer_credit_report": "客户信用报告",
	"customer_description": "客户详细",
	"customer_details": "顾客信息",
	"customer_id": "客户编号",
	"customer_information": "客户信息",
	"customer_management": "客户管理",
	"customer_name": "客户名称",
	"customer_name_colonsign": "客户名称",
	"customer_no": "客户编号",
	"customer_note": "客户备注",
	"customer_num": "客户编号",
	"customer_num_colonsign": "客户#：",
	"customer_order_schedule": "客户订货日程表",
	"customer_price_level": "客户价等级",
	"customer_return": "客户退货",
	"customer_rma": "客户 RMA",
	"customer_sales_history": "客户销售历史",
	"customer_statement": "客户报表",
	"customers": "客户",
	"customers2": "客户列表",
	"dashboard": "主页",
	"dashboard_v1": "主页 V1",
	"dashboard_v2": "主页 V2",
	"dashboard_v3": "主页 V3",
	"date": "日期",
	"date_filter": "过滤日期",
	"date_range": "日期范围",
	"dates": "日期",
	"days": "天数",
	"dead": "死货",
	"davis_po": "Davis PO",
	"decimal": "十进制",
	"default_address": "默认地址",
	"default_bin": "默认储位",
	"default_location": "默认位置",
	"default_location_colonsign": "默认位置:",
	"default_purchaser": "默认采购员",
	"default_sales": "默认销售员",
	"default_warehouse": "默认仓库",
	"default_warehouse_bin": "默认仓库储位",
	"default_warehouse_zone": "默认仓库区域",
	"default_zone": "默认区域",
	"default": "默认",
	"del": "删除",
	"delayed": "延误",
	"delete": "删除",
	"delete_file": "删除文件",
	"delete_product": "删除商品",
	"delete_purchase_order": "删除采购订单",
	"delete_purchase_template": "删除采购模板",
	"delete_successful": "删除成功",
	"delete_user": "删除用户",
	"deleted": "已删除",
	"deliver_date": "送货日期",
	"deliver_warehouse": "目的地仓库",
	"delivered": "交付",
	"delivery_warehouse": "送货仓库",
	"desc": "描述",
	"description": "描述",
	"detail": "详情",
	"detailed_excel": "详细导出",
	"detailed_information": "详细信息",
	"detailed_statement": "详细报表",
	"details": "细节",
	"details_&_convert": "",
	"details_&_repackage": "",
	"details_and_convert": "详细信息和转换",
	"details_and_repackage": "详细信息和重新包装",
	"dimension": "尺寸",
	"difference": "差异值",
	"disable": "停用",
	"disabled": "停用",
	"disc": "折扣",
	"discard_changes": "放弃更改",
	"discontinue": "停产",
	"discount": "折扣",
	"discount_description": "折扣描述",
	"dispatch": "调度计划",
	"dispatch_date": "发货日期",
	"dispatch_rma": "发送 RMA",
	"display": "显示类别",
	"distance": "距离",
	"document_date": "修改日期",
	"documented": "记录",
	"done": "完成",
	"draft": "草稿",
	"driver": "司机",
	"driver_license": "驾照号码",
	"dropship": "代购",
	"ds": "代购",
	"duplicate": "重复",
	"duplicate_product": "重复商品",
	"duplicate_product_promotion": "此商品已经被另一个促销使用。 是否继续添加？",
	"e_fax": "E传真",
	"edit": "编辑",
	"edit_agent": "编辑代理",
	"edit_bin": "编辑储位",
	"edit_category": "编辑类别",
	"edit_customer": "编辑客户",
	"edit_customer_confirm": "",
	"edit_customers": "编辑客户",
	"edit_display_category": "编辑显示类别",
	"edit_display_category_warning": "编辑前需要先创建产品",
	"edit_esl": "编辑电子标签",
	"edit_group": "编辑组别",
	"edit_groups": "编辑组别",
	"edit_invoice": "编辑发票",
	"edit_password": "编辑密码",
	"edit_payment": "编辑付款",
	"edit_payment_term": "编辑付款条款",
	"edit_product": "编辑商品",
	"edit_product_meta": "编辑商品元数据",
	"edit_purchase": "编辑采购单",
	"edit_purchase_order": "编辑采购订单",
	"edit_purchase_quote": "编辑采购报价单",
	"edit_purchase_return": "编辑采购退货",
	"edit_purchase_schedule": "编辑采购时间表",
	"edit_purchase_template": "编辑采购模板",
	"edit_put_away": "编辑放弃",
	"edit_released_si": "编辑销售发票",
	"edit_route": "编辑路线",
	"edit_routes": "编辑路线",
	"edit_sales_invoice": "编辑销售发票",
	"Edit_sales_order": "编辑销售订单",
	"edit_sales_order": "编辑销售订单",
	"edit_so": "编辑销售单",
	"edit_user": "编辑用户",
	"edit_username": "编辑用户名",
	"edit_vendor": "",
	"edit_warehouse": "编辑仓库",
	"edit_zone": "",
	"effect": "生效",
	"effect_date": "生效日期",
	"ein": "EIN",
	"email": "电子邮件",
	"email_address": "",
	"email_colonsign": "电子邮件：",
	"email_po": "电邮采购单",
	"email_so": "电邮订单",
	"employee_note": "员工备注",
	"enabled": "启用",
	"end": "结束",
	"end_date": "结束日期",
	"english": "英语",
	"eng_name": "英文名称",
	"chi_name": "中文名称",
	"enter_email_of_driver": "Enter the email of your driver",
	"error": "错误",
	"ESL": "电子标签",
	"esl_code": "电子标签号码",
	"esl_template": "电子标签模版",
	"est_date": "估计日期",
	"est_delivery": "预计送货",
	"is_no_reduce": "不扣库存",
	"est_receive_date": "预计接收日期",
	"est_sale_price": "预计销售价格",
	"et_sale_total": "预计总销售",
	"eta_date": "预计到货日期",
	"excel": "导出",
	"bank_account": "银行账户",
	"exit": "退出",
	"expire_date": "过期日期",
	"expired_date": "到期日",
	"expire_datetime": "过期日 (MM-DD-YYYY)",
	"expired_inventories": "过期库存",
	"expired_warning": "过期警告",
	"expiring": "即将到期",
	"export": "导出",
	"export_date": "到期日期",
	"export_inventories": "导出库存",
	"export_to_excel": "导出",
	"faq": "常见问题",
	"favorite_items": "建议商品",
	"favorite_list": "建议销售清单",
	"favorite_product_list": "收藏列表",
	"favorites_list": "收藏表",
	"fax": "传真",
	"fax_colonsign": "传真：",
	"field": "栏位",
	"file": "文件",
	"fill_with_latest_value": "最新的数据",
	"filter": "过滤",
	"final": "最终",
	"final_dollarsign": "最终价",
	"final_weight": "最终重量",
	"final_wt": "最终重量.",
	"finalize": "定案",
	"finalize_invoice": "定案发票",
	"finalize_si": "完成销售发票",
	"finalized": "敲定",
	"finish": "完成",
	"Finish_Shipping": "完成装运",
	"first_name": "名",
	"fob": "FOB",
	"fob_unit_price": "离岸价格",
	"free": "Free",
	"frequent_products": "常用货品",
	"Fri": "周五",
	"fri_route": "周五路线",
	"fri_stop": "周五停靠点",
	"from": "从",
	"from_bin": "",
	"full_list_table_sales_invoice": "销售发票列表",
	"full_list_table_sales_order": "完整列表 | 销售订单",
	"gv_rewards": "GV 奖励",
	"margin$": "余量 %",
	"nbt_rewards": "NBT 奖励",
	"general": "一般",
	"general_dashboard": "通用主页",
	"general_information": "基础信息",
	"general_management": "基础管理",
	"general_management2": "客户管理",
	"general_no": "通用编号",
	"generate_barcode": "生成条形码",
	"generate_all_barcode": "生成全部条形码",
	"generate_all_zone_barcode": "生成全部区域条形码",
	"index_no": "索引编号",
	"general_product_convert": "一般 | 商品转换",
	"general_product_repackage": "一般 | 商品重新包装",
	"general_report": "通用报表",
	"get": "Get",
	"gift_quantity": "商品赠送数量",
	"gift_quantity_column": "赠送数量",
	"good": "良好",
	"Good_Credit": "好信用",
	"grand_total": "累计",
	"group": "组别",
	"group_wholesale": "批发",
	"group_buy": "团购",
	"group_list": "类别列表",
	"group_name": "组别名",
	"groups": "组别",
	"groups_management": "组别管理",
	"handling": "手续费",
	"handling_cost": "手续费",
	"hmart_barcode": "HMart条形码",
	"hold": "保留",
	"id": "ID",
	"idx": "IDX",
	"image": "图片",
	"image_2": "图片 #2",
	"image_size_limit": "每个上传图片不能超过 7mb.",
	"import": "导入",
	"in_stock": "有现货",
	"in_stock_colonsign": "库存:",
	"in_stock_inactive": "有货/死货",
	"inactive": "非活动",
	"inbound": "入站",
	"inbound_area": "入库区",
	"inbound_plt": "入库板数",
	"insert_new_product_in_favorite_list": "输入建议销售清单",
	"instock": "现货",
	"internal_barcode": "内部条形码",
	"inv_cost": "库存成本",
	"inventories": "存货",
	"inventory": "库存",
	"inv": "库存",
	"inventory_adjust_sheet_warehouse_loc": "库存调整表 | 仓库位置",
	"inventory_adjust_warehouse_loc": "库存调整 | 仓库位置",
	"inventory_adjustment": "库存调整",
	"inventory_adjustment_sheet": "库存调整表",
	"inventory_adjustments": "库存调整",
	"inventory_convert": "库存转换",
	"inventory_convert_sheet": "库存转换表",
	"inventory_convert_sheet_warehouse_location": "库存转换工作表 | 仓库位置",
	"inventory_convert_warehouse_location": "库存转换 | 仓库位置",
	"inventory_converts": "转换库存",
	"inventory_detail": "库存明细",
	"inventory_details": "库存详细",
	"inventory_expired_passed_due": "存货过期 / 库存到期",
	"inventory_information": "库存信息",
	"inventory_number": "库存号码",
	"inventory_price": "库存总价",
	"inventory_receive": "库存接收",
	"inventory_receive_details": "库存接收详情",
	"inventory_receive_information": "库存接收信息",
	"inventory_receive_sheet": "库存接收表",
	"inventory_relocation": "库存搬迁",
	"inventory_relocation_sheet": "库存搬迁工作表",
	"inventory_relocation_sheet_warehouse_location": "库位迁移表 | 仓库位置",
	"inventory_relocation_warehouse_location": "库存迁移 | 仓库位置",
	"inventory_relocations": "库存搬迁",
	"inventory_repackage": "库存重新包装",
	"inventory_repackage_sheet": "库存重新包装表",
	"inventory_repackage_warehouse_loc": "库存重新包装 | 仓库位置",
	"inventory_scrap": "库存报废",
	"inventory_scrap_sheet": "库存报废表",
	"inventory_scrap_sheet_warehouse_location": "库存报废单 | 仓库位置",
	"inventory_scrap_warehouse_location": "库存报废 | 仓库位置",
	"inventory_transfer": "转移库存",
	"invoice": "发票",
	"invoice_amount": "发票金额",
	"invoice_date": "发票日期",
	"invoice_date_colonsign": "发票日期：",
	"invoice_final_dollarsign": "发票最终 $",
	"invoice_no": "发票编号",
	"invoice_no_colonsign": "发票编号：",
	"invoice_not_received": "未收货发票",
	"invoice_total": "发票总额",
	"invoice_type": "发票类型",
	"invoices_not_finalized": "未结算发票",
	"invoice_vendor": "供货商发票号码",
	"invoiced": "已发票",
	"invoiced_cost": "已发票 / 成本",
	"is_at_inbound_area": "在收货区",
	"is_at_outbound_area": "在出货区",
	"is_dropship": "Dropship",
	"is_enabled": "启用*",
	"is_public": "公开",
	"issue_credit": "问题信用",
	"issue_return": "",
	"item_count": "物品数量",
	"Item_is_out_of_stock": "缺货",
	"item_name": "项目名",
	"item_no": "编号",
	"lang": "语言",
	"large_label_mac": "大标签MAC",
	"large_label_win": "大标签WIN",
	"last_dollarsign": "最后价格",
	"last_modified_by": "最后修改",
	"last_month": "上个月",
	"last_name": "姓",
	"lb": "磅",
	"level": "层",
	"levels": "层",
	"level_1": "1级",
	"level_2": "2级",
	"level_3": "3级",
	"level_4": "4级",
	"level_5": "5级",
	"lg": "大",
	"limit": "显示数量",
	"limit_qty_order": "限制数量/订单",
	"limit_qty_order_desc": "(零代表无限制)",
	"link_existing_prod": "关联现有商品",
	"linked_so_no": "关联订单",
	"list_of_adjustment_lines": "库存调整行列",
	"list_of_inventory_convert_lines": "库存转换的列表",
	"list_of_inventory_relocation_lines": "库存搬迁行列表",
	"list_of_inventory_repackage_lines": "",
	"list_of_inventory_scrap_lines": "库存报废列表",
	"list_of_repackage_lines": "库存重新包装列表",
	"loaded_qty": "加载数量",
	"loaded_quantity": "",
	"location": "位置",
	"location_bin": "区域",
	"login": "登录",
	"login_in": "",
	"logo": "Logo",
	"logout": "登出",
	"low_stock": "低库存",
	"low_stock_inventories": "低库存",
	"low_stock_inventory": "低库存",
	"lowest_amount": "最低价格",
	"lowest_amt": "最低数量",
	"lowest_sale_dollarsign": "最低售价",
	"lv1": "一等价格",
	"lv2": "二等价格",
	"lv3": "三等价格",
	"lv4": "四等价格",
	"lv5": "五等价格",
	"mailing": "",
	"mailing_address": "",
	"mailing_contact": "",
	"mailing_contact_information": "邮寄联系",
	"mailing_details": "邮寄明细",
	"mailing_information": "邮件信息",
	"manage_active_users": "管理用户",
	"manage_customers": "管理客户",
	"manage_promotions": "管理促销",
	"march": "",
	"margin": "余量",
	"match": "相符",
	"max": "最大",
	"max_limit": "最大",
	"max_limit_colonsign": "最大值:",
	"max_stock_range": "最大库存范围",
	"measure": "规格单位",
	"measure_unit": "规格",
	"memo_no": "Memo 号码",
	"memo_poundsign": "备注 #",
	"merchant_report": "销售商报告",
	"merchant_summary": "销售商汇总",
	"meta_info": "元数据",
	"method": "方法",
	"middle_name": "中间名字",
	"min": "最小",
	"min_purchase_amount": "最低购买价值",
	"min_limit": "最小",
	"min_limit_colonsign": "最小值:",
	"min_stock_range": "最小库存范围",
	"misc": "杂项",
	"misc_cost": "杂费",
	"misc_cost_detail": "杂费内容",
	"misc_cost_details": "杂项明细",
	"misc_detail": "其他明细",
	"misc_dollarsign": "杂费",
	"misc_fee": "杂项费用",
	"mix_product": "混合产品",
	"mix_setting": "混合配置",
	"mm": "规格",
	"mm_type": "规格类型",
	"mm_unit": "规格单位",
	"mobile": "移动电话",
	"mobile_customer_statement": "手机客户报表",
	"mobile_dollarsign": "手机$",
	"mobile_description_box": "产品描述修改",
	"mobile_management": "手机管理",
	"mobile_sale": "手机销售",
	"mobile_sales_order": "手机销售订单",
	"mobile_username": "手机客户用户名",
	"mobile_users": "手机用户",
	"modified": "修改",
	"modified_by": "修改者",
	"modified_on": "修改日期",
	"modified_time": "修改时间",
	"modifier": "修改人员",
	"modify": "修改",
	"modify_inventory": "修改库存",
	"modify_username": "修改用户名",
	"Mon": "周一",
	"mon_route": "周一路线",
	"member_card": "会员卡",
	"mon_stop": "周一停靠点",
	"month": "月",
	"Monthly": "月",
	"more_info": "更多",
	"multilevel_marketing": "多层销售",
	"move_all": "移动全部",
	"move_selected": "移动选择",
	"move_off": "",
	"move_off_from_list": "从列表中移出",
	"move_off_from_products_list": "从商品列表移除",
	"move_off_products_list": "从商品列表移除",
	"move_to": "",
	"move_to_list": "移动到列表",
	"move_to_po": "移至采购单",
	"move_to_product_list": "移动到商品列表",
	"move_to_products_list": "移动到商品列表",
	"move_to_so": "移动到销售单",
	"move_to_so_list": "移动到销售订单列表",
	"msg_po_to_so_dropship": "确定 SO 到 PO (Davis)?",
	"msg_add_duplicate_item": "您加入了重复的物品",
	"msg_assign_customer": "分配此单给客户:",
	"msg_agree_terms": "我同意上述条款",
	"msg_ask_for_manager_login": "输入经理的用户名与密码",
	"msg_ask_if_stay_on_current_page": "是否要留在当前页面？",
	"msg_confirm_add_customer_to_group": "此动作将从旧群组移除此客户，确定继续？",
	"msg_confirm_change_group_without_save_products": "尚未储存商品信息，确定继续？",
	"msg_confirm_delete": "确定要删除？",
	"msg_confirm_print_tracking": "订单已有追踪号码. 是否继续打印标签?",
	"msg_confirm_refund_order": "你确定要退款吗？",
	"msg_confirm_reship": "确定补发此订单?",
	"msg_confirm_quote": "确定把报价单别为购买单?",
	"passcode_confirm": "密码确认",
	"your_passcode_is_not_correct": "密码不正确",
	"msg_convert_qty_cannot_exceed_current_qty": "转换数量不能大于当前数量",
	"msg_drag_drop_attachment": "尝试在此处删除一些文件，或单击以选择要上传的文件。",
	"msg_drop_upload_files": "拖放上传文件或点击选择文件",
	"msg_enter_scrap_amount_and_inventory_will_be_updated": "输入下方的报废数量，并更新库存",
	"msg_export_order_stats": "导出用户统计信息会需要1分钟，请不要离开页面",
	"msg_grand_total_equation": "＊ 累计 ＝ 总计 － 已取消",
	"msg_inventory_price_equation": "* 库存总价 = 平均库存价 × 库存",
	"msg_item_already_in_sales_order": "此项目已在销售订单",
	"msg_large_prod": "箱 (大货)",
	"msg_no_permission": "您没有当前操作的权限。",
	"msg_operation_saved": "您的操作已储存",
	"msg_please_select_a_vendor": "请选择一个供货商",
	"msg_product_image_modal_desc": "* 请在关闭弹窗前保存图片",
	"msg_products_loaded_click_save_to_complete": "所有商品已载入，点击储存已完成订单",
	"msg_purchase_order_num_is": "采购单编号为",
	"msg_purchase_order_saved": "您的采购单已储存",
	"msg_purchase_quote_generated": "您的采购报价单已生成",
	"msg_purchase_quote_saved": "您的采购报价单已储存",
	"msg_purchase_template_saved": "您的采购模板已储存",
	"msg_relocation_qty_cannot_exceed_current_qty": "搬迁数量不能大于当前数量",
	"msg_repackage_qty_cannot_exceed_current_qty": "重新包装数量不能大于当前数量",
	"msg_scrap_qty_cannot_exceed_current_qty": "报废数量不能大于当前数量",
	"msg_select_a_group": "选择一个组别",
	"msg_select_a_purchase_template": "选择采购模板",
	"msg_select_an_inventory_as_target": "选择一个目标库存",
	"msg_select_an_inventory_to_adjust": "选择一个库存来调整",
	"msg_select_an_inventory_to_convert": "选择一个库存来转换",
	"msg_select_an_inventory_to_relocate": "选择一个库存来搬迁",
	"msg_select_an_inventory_to_repackage": "选择一个库存来重新包装",
	"msg_select_an_item": "选择一个商品",
	"msg_select_customer": "选择客户",
	"msg_select_from_batch": "从批次选择",
	"msg_select_warehouse": "选择仓库",
	"msg_select_warehouse_bin": "选择仓库储位",
	"msg_select_warehouse_zone": "选择仓库区域",
	"msg_show_action_log_from_last_90_days": "显示过去 90 天的修改记录",
	"msg_small_prod": "个 (小货)",
	"msg_total_orders_equation": "＊ 总订单数 ＝ 订单数 － 已取消订单",
	"MSO": "MSO",
	"n1_prod_qty": "N1 商品数量",
	"n2_prod_qty": "N2 商品数量",
	"name": "名称",
	"nationwide": "全国销售",
	"need_to_signup": "",
	"negative": "负",
	"net": "实收金额",
	"net_cost": "库存成本",
	"net_receiving": "应收金额",
	"net_weight": "净重",
	"net_wt": "商品重量",
	"new_password": "新密码",
	"new_purchase_order": "新采购单",
	"new_purchase_quote": "新采购报价",
	"new_purchase_template": "新采购模板",
	"new_quantity": "新的数量",
	"new_receiving": "新收货",
	"new_sales_order": "新销售单",
	"new_sales_return": "新的销售退货",
	"new_scrap_record": "新纪录",
	"new_series_no": "新系列号",
	"new_so": "新销售订单",
	"new_username": "新用户名",
	"new_value": "新数值",
	"next_execute_date": "下个执行时间",
	"prev_page": "上一页",
	"next_page": "下一页",
	"No": "否",
	"no": "否",
	"no_bin_range": "无储位范围",
	"no_invoice": "",
	"no_pickup": "",
	"no_mix_product": "没有混合物品",
	"no_shipping_address": "",
	"no_shipping_information": "没有运输信息",
	"no_vendor": "没有供货商",
	"non_fixed": "不固定重量",
	"non_food": "非食物",
	"non_zero": "非零",
	"none": "没有",
	"not_shipped_quantity": "未发送数量",
	"not_yet_received": "未收货",
	"notation": "备注",
	"note": "备注",
	"notes_for_pos": "POS的注意事项",
	"notes_for_sales": "销售记录",
	"num": "编号",
	"number": "编号",
	"number_of_card_transactions": "卡片交易数量",
	"number_of_checks": "支票数量",
	"off_stock": "关闭现货",
	"offrate": "Offrate",
	"old_value": "旧数值",
	"on_hold": "搁置",
	"on_fleet": "Onfleet",
	"on_sale": "可售",
	"on_stock": "打开现货",
	"one_time": "单次",
	"one_time_schedule": "上次时间",
	"one_time_use": "单次使用",
	"oops": "",
	"open": "未发货",
	"open_draft": "",
	"open_sales_orders": "打开销售单",
	"optional": "Optional",
	"order": "订单",
	"order_amount": "订单数量",
	"order_count_overview": "下单数总览",
	"order_date": "订购日期",
	"order_history": "历史订单",
	"order_num": "订单编号",
	"order_qty": "订单数量",
	"order_stats": "订单统计",
	"order_status": "订单状态",
	"order_total": "订单总价",
	"order_total_dollarsign": "订单总价 $",
	"order_type": "订单类型",
	"order_unit": "订单单价",
	"order_unit_dollarsign": "订单单价 $",
	"ordered": "下单",
	"orders": "订单",
	"out_of_stock": "缺货",
	"out_of_stock_active": "无货/缺货",
	"outbound": "出库区",
	"outbound_area": "出库区",
	"outbound_plt": "出库板数",
	"outstanding": "未付金额",
	"outstanding_invoice": "未付发票",
	"outstanding_order": "未到订单",
	"over_stock": "高库存",
	"oversaleable": "可超卖",
	"owner": "所有者",
	"package": "包",
	"package_details": "包装详细",
	"package_dimension_shipping": "包装尺寸运输",
	"package_size": "包装尺寸",
	"packageSize": "包装尺寸",
	"package_slashsign_weight": "包装 / 重量",
	"package_type": "包装类型",
	"package_weight_shipping": "包装重量运输",
	"packaging": "包装",
	"packing": "包装中",
	"packing_num": "包装号码",
	"paid_dollarsign": "已付金额",
	"pallet": "栈板",
	"partial": "部分接收",
	"pass": "忽略",
	"passed_due": "过期",
	"password": "密码",
	"payment": "付款",
	"payment_amount": "支付金额",
	"payment_date": "付款日期",
	"payment_detail": "付款细节",
	"payment_details": "付款细节",
	"payment_info": "",
	"payment_method": "付款方法",
	"payment_status": "支付状态",
	"payment_summary": "支付统计",
	"payment_term": "付款条款",
	"payment_term_short": "付款条款",
	"payment_term_name": "付款条款名称",
	"payment_terms_management": "付款条款管理",
	"payment_type": "付款方式",
	"per_pallet": "栈板",
	"per_pound": "每磅",
	"percentsign_off": "％ 折扣",
	"permission_name": "权限名称",
	"phone": "电话",
	"pickup": "提货",
	"pickup_contact": "供货商联系人",
	"pickup_poundsign": "提货 #",
	"pickup_vendor_address": "供货商提货地址",
	"pickup_warehouse": "提货仓库",
	"pickup_warehouse_name": "供货商提货地址",
	"piece (small prod)": "小货",
	"piece": "个",
	"pkg_type": "包装类型",
	"place_new_order": "产生采购订单",
	"new_outbound_order": "创建出库单",
	"new_inbound_order": "创建入库单",
	"percentage_fee": "百分比费用",
	"flat_fee": "固定费用",
	"credit_amount": "钱包额度",
	"placed": "下单",
	"plain_statement": "简单声明",
	"please_enter_a_valid_email": "Please enter a valid email!",
	"please_select_an_end_date_that_is_after_the_start_date": "Please select an end date that is after the start date.",
	"please_select_a_start_date_that_is_before_the_end_date": "Please select a start date that is before the end date.",
	"please_select_a_contact": "请选择一个联系人",
	"please_select_a_customer": "请选择客户",
	"please_select_a_product": "请选择一个商品",
	"please_select_an_inventory": "请选择一个库存",
	"please_select_category": "请选择类别",
	"please_select_group": "请选择组别",
	"please_select_inventory": "请选择库存",
	"pmt_date": "支付日期",
	"pmt_status": "付款状态",
	"po_date": "采购单日期",
	"po_details": "采购单明细",
	"po_final_dollarsign": "采购单最终 $",
	"po_num": "采购单编号",
	"po_purchase_status": "采购单状态",
	"po_scheduled_arrival": "采购单预计到达",
	"po_scheduled_to_arrive": "采购单预计到达",
	"po_status": "采购单状态",
	"poor": "差",
	"pos": "收银机",
	"pos_management": "POS管理",
	"pos_credit": "POS 信用",
	"pos_order": "POS 单",
	"pos_order_credits": "POS 信用列表",
	"pos_order_full_table": "POS 全单列表",
	"pos_report": "收银机报告",
	"posting_date": "发布日期",
	"pr_no": "采购退货单编号",
	"presale": "预售",
	"presale_colonsign": "预售:",
	"president_dashboard": "总数据主页",
	"press_enter_for_emails": "按回车输入电子邮件",
	"press_enter_to_confirm_weights": "",
	"preview": "预览",
	"previous": "之前",
	"previous_orders": "以前的订单",
	"price": "价钱",
	"price_1": "价格1",
	"price_2": "价格2",
	"price_3": "价格3",
	"price_4": "价格4",
	"price_adjustment": "价格调整表",
	"price_adjustment_chart": "价格调整表",
	"price_level": "价格水平",
	"price_level_percent": "价格百分比",
	"sales_price_levels": "价格水平设置",
	"sales_type": "销售类型",
	"price_lvl": "价格等级",
	"price_range_warning": "输入PASSCODE确认身份再继续之前动作",
	"price_reference": "价格调整表",
	"price_reference_chart": "价格调整表",
	"print": "打印",
	"print_new_label": "打印新标签",
	"print_no": "打印编号",
	"print_barcode": "打印条形码",
	"print_general_information": "打印基本信息",
	"print_invoice": "打印发票",
	"print_label": "打印标签",
	"print_picking_list": "打印拣货单清单",
	"print_po": "打印采购单",
	"print_purchase_order": "打印采购订单",
	"print_purchase_payment": "打印购买付款",
	"print_reminder": "打印提示",
	"print_shipping": "打印运送",
	"print_shipping_sheet": "打印运输单",
	"print_si": "打印发票",
	"print_so": "打印销售单",
	"print_specifications": "打印规格",
	"print_statements": "打印报表",
	"printing_information": "打印信息",
	"process_purchase_return": "执行采购退货",
	"process_sales_return": "执行销售退货",
	"processing_fee": "手续费",
	"prod2_desc": "商品 2 描述",
	"prod2_name": "商品 2 名称",
	"prod2_num": "商品 2 编号",
	"prod2_qty": "商品 2 数量",
	"prod2_ref_num": "商品 2 参考编号",
	"prod_barcode": "商品条形码",
	"prod_cost": "商品成本",
	"prod_group": "商品组别",
	"prod_name": "商品",
	"prod_num": "商品编号",
	"prod_type": "商品类型",
	"product": "商品",
	"product_barcode": "商品条形码",
	"product_categories": "商品类别",
	"product_category_1": "商品类别 1",
	"product_category_2": "商品类别 2",
	"product_convert": "大小货调整表",
	"product_convert_page": "商品转换",
	"product_cost": "商品成本",
	"product_cost_and_price": "商品成本和价格",
	"product_description": "",
	"product_detail": "商品细节",
	"product_details": "商品详细",
	"product_does_not_exist": "商品不存在",
	"product_filter": "商品",
	"product_group": "商品组别",
	"product_group_and_category": "商品组别和类别",
	"product_groups": "商品组别",
	"product_information": "商品信息",
	"product_list": "商品列表",
	"product_location_detail": "商品详情储位",
	"product_management": "商品管理",
	"product_name": "商品名称",
	"product_not_found": "商品号不存在",
	"product_num": "商品编号",
	"product_num_ref_num": "商品编号/参考编号",
	"product_price": "商品价格",
	"product_purchased": "商品采购",
	"product_repackage_sheet_product_repackage": "商品名称",
	"product_sku": "产品 SKU",
	"product_to_return": "商品退还",
	"product_type": "商品类别",
	"product_unit_of_measure": "",
	"product_unit_weight_price": "商品单位重量价格",
	"products": "商品",
	"products_list": "",
	"profile": "详细",
	"profit": "利润",
	"profit_percentage": "利润百分比",
	"profit_pl": "实际利润比",
	"promo": "促销",
	"promo_code": "Promo Code",
	"promotion": "促销",
	"promotion_management": "商品名称",
	"promotion_name": "商品名称",
	"promotions": "促销",
	"Proposition65": "Proposition 65",
	"puchase_payment_detail": "购买付款明细",
	"pull_sheet_format": "Pull Sheet 格式化",
	"purchase": "采购",
	"purchase_dashboard": "采购主页",
	"purchase_date": "采购日期",
	"purchase_date_colonsign": "采购日期名称",
	"purchase_information": "采购信息",
	"purchase_management": "采购管理",
	"purchase_no": "采购号码",
	"purchase_order": "采购订单",
	"purchase_order_date": "采购单日期",
	"purchase_order_dates": "采购单日期",
	"purchase_order_detail": "采购单明细",
	"purchase_order_details": "采购单明细",
	"purchase_order_expect_coming_today": "采购订单预计今日到达",
	"purchase_order_full_list": "采购单完整列表",
	"purchase_order_full_table": "采购单表",
	"purchase_order_no": "采购订单编号",
	"purchase_order_not_received": "采购订单未收货",
	"purchase_order_number": "采购单编号: ",
	"purchase_order_receive_rate": "采购单收货率",
	"purchase_order_requires_products": "采购订单需要商品”",
	"purchase_orders_arrive_today": "预计当天到货采购订单",
	"purchase_payment": "采购单付款",
	"purchase_payment_details": "采购付款明细",
	"purchase_payments": "采购付款",
	"purchase_performance": "采购状况表",
	"purchase_pivot": "采购模板对比表",
	"purchase_pivot_chart": "采购视图",
	"purchase_quote": "采购报价",
	"purchase_quote_details": "采购报价明细",
	"purchase_quote_full_table": "采购报价表",
	"purchase_reference": "采购参考表",
	"purchase_reference_report": "采购参考表",
	"purchase_report": "采购报告",
	"purchase_return": "采购退货",
	"purchase_return_details": "采购退货细节",
	"purchase_return_list": "采购退货表",
	"purchase_return_num": "商品名称",
	"purchase_sales": "已收货 / 已发票",
	"purchase_schedule": "采购时间表",
	"purchase_statistics": "采购统计",
	"purchase_status": "采购状态",
	"purchase_template": "采购模板",
	"purchase_template_details": "采购模板明细",
	"purchase_template_full_table": "采购模板表",
	"purchase_template_must_have_products": "“采购模板必须有商品”",
	"purchase_template_no": "采购模板编号",
	"purchase_template_unavailable": "采购模板不可用",
	"purchase_user": "采购用户",
	"purchased": "购买",
	"purchased_by": "采购人员",
	"purchased_colonsign": "采购:",
	"purchaser": "采购人员",
	"purchaser_name": "",
	"purchasing": "采购",
	"purchasing_performance": "采购业绩",
	"put_away": "放置",
	"put_away_form": "",
	"put_away_list": "放弃列表",
	"put_away_num": "放弃数量",
	"putaway_quantity": "",
	"qty": "数量",
	"box": "数量",
	"qty_from": "原数量",
	"qty_to": "新数量",
	"quantity": "数量",
	"quantity_cannot_have_a_zero_value": "不能为 0",
	"quantity_colonsign": "数量：",
	"quantity_weight": "数量/ 重量",
	"quarter": "季",
	"quick_actions": "快速操作",
	"quote_reference": "采购报价单",
	"quote_reference_chart": "采购视图",
	"quote_reference_chart_detail": "采购视图明细",
	"range": "范围",
	"rate": "商品名称",
	"rcv_qty": "接收数量",
	"rcv_box": "接收数量",
	"rcv_quantity": "收货数量",
	"rcv_total_price": "收货总价格",
	"reading_data": "读取数据",
	"reason_for_return": "退货原因",
	"receipt": "收据",
	"receipt_no": "收据编号",
	"receive": "收货",
	"receive_all": "全部接收",
	"receive_date": "收货日期",
	"receive_detail": "",
	"receive_dollarsign": "收货价",
	"receive_final_dollarsign": "收货单最终 $",
	"receive_history": "收货历史",
	"receive_history_detail": "收货历史详细",
	"receive_list": "接收列表",
	"receive_num": "收货编号",
	"receive_qty": "收货数量",
	"receive_total_dollarsign": "收货总价",
	"receive_total_price": "",
	"receive_total_wt": "收货总重",
	"receive_unit_dollarsign": "收货单价",
	"receive_unit_price": "",
	"received": "已收货",
	"receiver": "收货人员",
	"receiving": "收货",
	"receiving_date": "接收日期",
	"receiving_details": "接收详细信息",
	"receiving_history": "接收历史",
	"receiving_information": "接收信息",
	"receiving_list": "收货单",
	"record_adjustment_no": "记录（调整）编号",
	"record_convert_no": "记录(转换)号",
	"record_relocation_no": "",
	"record_repackage_no": "记录（重新包装）编号",
	"record_scrap_no": "记录报废NO",
	"recreate": "重建",
	"refresh_system": "刷新系统",
	"confirm_refresh": "确认加载和刷新系统?",
	"ref_barcode": "参考条形码",
	"ref_cost": "参考成本",
	"ref_price": "参考价格",
	"ref_cost_price": "参考价格",
	"ref_dollarsign": "参考价格",
	"ref_num": "参考号",
	"item_num": "参考号",
	"ref_purchasing_price": "参考采购价",
	"refer_purchasing_price": "参考采购价",
	"refund": "退款",
	"refund_amount": "退款金额",
	"refund_successful": "退款成功",
	"related": "有关",
	"related_no": "关联号码",
	"related_product": "关联商品",
	"release": "发货",
	"released": "已发货",
	"relocate": "搬迁",
	"relocate_quantity": "搬迁数量",
	"relocate_some_or_all_of_the_selected_inventory": "部分或全部库存搬迁",
	"relocate_user": "搬迁执行者",
	"relocation": "搬迁",
	"relocation_date": "",
	"relocation_destination": "搬迁目的地",
	"relocation_quantity": "搬迁数量",
	"remark": "备注",
	"remember_me": "记住我",
	"remove": "移除",
	"remove_from_so_list": "从销售列表中删除",
	"repackage": "重新包装",
	"repackage_date": "重新包装日期",
	"repackage_destination": "重新打包目的地",
	"repackage_quantity": "重新包装数量",
	"repackage_target_quantity": "重新包装目标数量",
	"repackage_user": "重新包装用户",
	"repeat_frequency": "重复频率",
	"repeat_interval": "重复间隔",
	"repeat_on": "重复",
	"report": "报表",
	"resale_no": "Resale号",
	"reseller": "Reseller",
	"reset_all": "重置全部",
	"reset_email": "重置电子邮件",
	"reset_password": "重置密码",
	"reship": "补发",
	"restocking_fee": "退货费用",
	"return": "返回",
	"rtned_qty": "已退货数量",
	"return_date": "退货日期",
	"return_details": "退货明细",
	"return_no": "退货号",
	"return_order_info": "采购退货单信息",
	"return_qty": "退货数量",
	"return_quantity": "退还数量",
	"return_reason": "退货原因",
	"return_status": "退货状态",
	"return_this_product": "退还商品",
	"return_unit_price": "回单位价格",
	"returns": "退货",
	"retype_password": "",
	"rewards": "奖励",
	"role_management": "角色管理",
	"role_name": "角色名称",
	"route": "路线",
	"route_details": "路线详情",
	"route_num": "路线编号",
	"route_number": "路线编号",
	"routing": "排线",
	"rtn_quantity": "退货数量",
	"sale": "销售",
	"sale_details": "销售细节",
	"sale_dollarsign": "售价",
	"sale_invoice_details": "销售发票明细",
	"sale_order_details": "销售单明细",
	"sale_price": "售价",
	"sale_qty": "销售数量",
	"saleable": "可售",
	"sales": "销售",
	"sales_colonsign": "销售：",
	"sales_cost": "销售额 / 成本",
	"sales_dashboard": "销售主页",
	"sales_history": "销售历史",
	"sales_inventory_value": "销售价值/库存价值",
	"sales_invoice": "销售发票",
	"sales_invoice_detail": "销售发票的明细",
	"sales_invoice_details": "发票明细",
	"sales_invoice_full_table": "销售发票全表",
	"sales_invoices_today": "今日销售发票",
	"sales_management": "销售管理",
	"sales_management2": "订单管理",
	"sales_margin_percentsign": "销售利润 %",
	"sales_margin_master_percentsign": "销售利润(M) %",
	"sales_order": "销售订单",
	"sales_order_dates": "销售订单日期",
	"sales_order_details": "销售订单明细",
	"sales_order_full_table": "销售订单全表",
	"sales_order_list": "销售订单列表",
	"sales_order_no": "销售订单编号",
	"sales_order_rate": "销售订单比例",
	"sales_orders": "销售订单",
	"sales_orders_open": "未出货销售订单",
	"sales_orders_ship_today": "预计当天出货销售订单",
	"sales_performance": "销售绩效表",
	"sales_performance_list": "销售业绩表",
	"sales_report": "销售报告",
	"sales_return": "销售退货",
	"sales_returned": "销售退货",
	"same_as_billing_address": "与付款地址相同",
	"same_as_billing_contact": "与付款联系人相同",
	"same_as_billing_information": "与付款信息相同",
	"Sat": "周六",
	"sat_route": "周六路线",
	"sat_stop": "周六停靠点",
	"saturday": "周六",
	"save": "保存",
	"save_and_print": "保存打印",
	"save_changes": "",
	"save_draft": "保存草稿",
	"save_successful": "保存成功",
	"save_weights": "保存重量",
	"saved": "保存完成",
	"saved_tracking_note": "此采购单追踪笔记已保存",
	"schedule_shipping_date": "预计发货日期",
	"scheduled": "规划",
	"scheduled_to_ship": "规划发货",
	"scheduled_shipping_date": "预计发货日期",
	"scrap": "报废",
	"scrap_amount": "报废数量",
	"scrap_date": "报废日期",
	"scrap_product_details": "报废商品明细",
	"scrap_qty": "报废数量",
	"scrap_quantity": "报废数量",
	"scrap_record": "报废记录",
	"scrap_records": "报废记录",
	"scrap_some_or_all_of_the_selected_inventory": "报废部分或全部选定的库存",
	"scrapping": "报废",
	"service_code": "Service Code",
	"search": "搜索",
	"search_by": "搜索类别",
	"search_prod": "搜索商品:",
	"search_prod_by": "搜索商品",
	"search_type": "搜索类别:",
	"sectioned_list": "Sectioned List",
	"select": "选择",
	"select_a_product_to_scrap": "选择商品进行报废",
	"select_a_purchase_order": "选择采购订单",
	"select_an_inventory_item": "选择库存商品",
	"select_customer_information": "选择客户信息",
	"select_group": "选择组别",
	"select_inventory_to_scrap": "选择库存报废",
	"select_purchase_template": "选择购买模板",
	"select_purchaser": "选择采购员",
	"select_receive_history": "",
	"select_seller": "选择卖家",
	"select_vendor": "选择供货商",
	"selected_bins": "选择储位",
	"seller": "销售员",
	"set_order": "定位订单",
	"set_schedule": "设定的时间表",
	"set_various_weight": "设置不固定重量",
	"set_weights": "",
	"setting": "设置",
	"share": "分享",
	"share_cost": "攤入成本",
	"sheet_not_completed_warning": "",
	"shelf_life": "保质期",
	"shift_life_day": "保质期(日)",
	"shelf_life_statistics": "保质期统计",
	"ship_dollarsign": "运费",
	"ship_to": "运送到",
	"ship_weight": "运输重量",
	"ship_wt": "运输重量",
	"shipment_date": "发货日期",
	"shipped": "发货",
	"shipped_qty": "发货数量",
	"shipping": "运输",
	"shipping_address": "送货地址",
	"shipping_address_poundsign": "送货地址 #",
	"shipping_cost": "运费",
	"shipping_cost_details": "运费成本细节",
	"shipping_cost_information": "运输成本",
	"shipping_date": "发货日期",
	"shipping_details": "送货明细",
	"shipping_dollarsign": "运费",
	"shipping_fee": "运输费用",
	"shipping_information": "运输信息",
	"shipping_method": "运输方式",
	"shipping_poundsign": "运输 #",
	"shipping_weight": "运输重量",
	"shipto": "运送到",
	"show_as": "Show As",
	"show": "显示",
	"hide": "隐藏",
	"show_price": "显示价格",
	"show_finalized_si": "显示完成销售发票",
	"show_released_si": "显示销售发票",
	"si_dollarsign": "发票$",
	"si_no": "发票号码",
	"si_payment": "",
	"si_status": "发票状态",
	"sign_in_to_continue": "",
	"simplified_excel": "简化导出",
	"simplified_statement": "简化报表",
	"size": "尺寸",
	"sm": "小",
	"small_catch_weight": "小货不固定重量",
	"small_label": "小标签",
	"small_net_weight": "小货重量",
	"small_product_no": "小货编号",
	"so_dollarsign": "销售$",
	"so_no": "销售单编号",
	"so_scheduled_shipping": "SO预计发货",
	"so_to_po": "SO 到 PO",
	"sold": "出售",
	"space_not_enough_create_bins": "",
	"space_not_enough_relocate": "",
	"specify": "指定",
	"split_tracking_numbers": "分包追踪号码",
	"spreadsheet": "导入表格",
	"start": "开始",
	"start_date": "开始日期",
	"state": "州",
	"statement_range": "报表范围",
	"status": "状态",
	"stock": "库存",
	"stock_left_after_1_week": "一周后剩馀库存",
	"stock_range": "库存范围",
	"stop": "停靠",
	"stop_purchase": "停卖",
	"stop_route": "停止路线",
	"stop_sale": "停售",
	"stopsale": "停售",
	"storage_rate": "仓储费用",
	"store_credit_dollarsign": "低佣金$",
	"street": "街",
	"sub_menu": "",
	"submit": "提交",
	"subtitle": "",
	"subtotal": "小计",
	"suite": "单元号",
	"success": "成功",
	"Sun": "周日",
	"sun_route": "周日路线",
	"sun_stop": "周日停靠点",
	"sync_scale": "同步电子秤",
	"sync_esl": "同步电子标签",
	"target_weight": "目标重量",
	"Tax": "TAX:",
	"tax": "税",
	"tax_code": "税号",
	"tax_management": "税率管理",
	"taxable": "交税",
	"tel": "联系电话",
	"tel_colonsign": "电话：",
	"telephone": "电话",
	"temperature": "存放温度",
	"template_name": "模板名称",
	"term_days": "",
	"term_type": "",
	"term_types": "类型",
	"test": "测试",
	"this_group": "此组别",
	"this_customer_is_already_in_the_group": "This customer is already in the group.",
	"thu_route": "周四路线",
	"thu_stop": "周四停靠点",
	"Thur": "周四",
	"thurs_route": "周四路线",
	"thurs_stop": "周四停靠点",
	"to": "到",
	"to_bin": "到储位",
	"to_zone": "到区域",
	"tooltip_customer_bypass_payment": "Bypassing payments will let mobile users skip mobile payment, and pay with AR.",
	"tooltip_customer_manager": "Manager users can see all past orders for this business customer.",
	"today": "今天",
	"total": "总计",
	"total_amount": "总金额",
	"total_ap": "总应付",
	"total_ar": "总应收",
	"total_bin": "",
	"total_bins": "总储位",
	"total_credit": "总额度",
	"total_customers": "总客户",
	"total_dollarsign": "总价",
	"total_inventory_price": "库存总价总计",
	"total_inventory_worth": "库存总价值",
	"total_invoice": "总发票",
	"total_net_weight": "总净重",
	"total_net_wt": "总净重",
	"total_orders_today": "订单总数",
	"total_price": "总价格",
	"total_price_colonsign": "总价：",
	"total_prod": "总数量",
	"total_purchases": "商品采购总额",
	"total_receive_price": "总收货金额",
	"total_return": "总退货",
	"total_sale": "总销售额",
	"total_sales_price": "总销售金额",
	"total_sales_worth": "总销售价值",
	"total_ship_wt": "总毛重",
	"total_shipping_weight": "总运输重量",
	"total_shipping_weight_lbs": "总运输重量 (磅)",
	"total_size": "尺寸总和",
	"total_storage_day": "总存储日",
	"total_unit": "总数量",
	"total_users": "总用户",
	"total_weight": "总重量",
	"total_wt": "总重量",
	"track_all": "追踪全部",
	"track_no": "追踪号码",
	"tracking_note": "追踪笔记",
	"tracking_num": "追踪号码",
	"tracking_nums": "追踪号码",
	"transaction_fee": "手续费",
	"transit_method": "运输方式",
	"translation": "翻译",
	"try_dropping_some_files_here,_or_click_to_select_files_to_upload": "尝试在此处放入文件，或单击以选择要上传的文件",
	"tue_route": "周二路线",
	"tue_stop": "周二停靠点",
	"Tues": "周二",
	"tues_stop": "周二停靠点",
	"type": "类型",
	"Typo": "id",
	"type_in_your_email": "輸入您的电子邮件",
	"type_in_your_password": "輸入您的密碼",
	"unassigned_orders": "未分配订单",
	"undo": "不做",
	"undone": "未完成",
	"unit": "单元",
	"unit_dollarsign": "单价",
	"unit_of_measure": "测量单位",
	"unit_per_pallet": "栈板规格",
	"unit_price": "单价",
	"unit_type": "Unit Type",
	"unit_price_colonsign": "单价:",
	"unload_all": "全部卸载",
	"unload_selected": "重置已选",
	"unpaid": "未付",
	"unpaid_amount": "未付金额",
	"update": "更新",
	"update_date": "",
	"update_dollarsign": "更新价格",
	"update_inventory": "更新库存",
	"update_no": "更新编号",
	"update_time": "更新时间",
	"upload": "上传文件",
	"upload_file": "上传文件",
	"upload_files": "上传文件",
	"upload_images": "上传图片",
	"uploading": "上传",
	"usable": "可用",
	"used_bin": "",
	"user": "用户",
	"user_amount": "用户数量",
	"use_product_a": "Use Product A",
	"user_detail": "用户信息",
	"user_management": "用户管理",
	"user_performance": "销售员业绩",
	"user_name": "用户名",
	"user_role": "用户角色",
	"username": "用户名",
	"variable_weight": "不固定重量",
	"vehicle": "车量",
	"vendor": "供货商",
	"vendor_add": "增加供货商",
	"vendor_description": "供货商说明",
	"vendor_details": "供货商信息",
	"vendor_id": "供货商号",
	"vendor_information": "供货商信息",
	"vendor_invoice_no": "供货商发票号码",
	"vendor_inv": "供货商发票号",
	"vendor_inv_date": "供货商发票日期",
	"vendor_name": "供货商名称",
	"vendor_no": "供货商编号",
	"mfr_no": "制造商编号",
	"vendor_num": "供货商编号",
	"vendor_number": "供货商编号",
	"vendor_products": "供货商商品",
	"vendor_product_number": "供货商商品编号",
	"vendor_statement": "供货商报表",
	"vendors": "供货商",
	"vendors_management": "供货商管理",
	"view_pos_order": "",
	"void": "作废",
	"void_note": "作废备注",
	"void_reason": "作废原因",
	"warehouse": "仓库",
	"warehouse_bin_id": "仓库储位 ID",
	"warehouse_bins": "仓库储位",
	"warehouse_dashboard": "仓库主页",
	"warehouse_detail_view": "仓库详细查看",
	"warehouse_id": "仓库 ID",
	"warehouse_management": "仓库管理",
	"warehouse_map_view": "仓库视图",
	"warehouse_name": "仓库名称",
	"warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_partially_received_": "收货单已删除。采购订单状态返回至 Partially Received。",
	"Warehouse_receive_deleted__purchase_orders_purchasestatus_rolled_back_to_placed_": "收货单已删除。采购订单状态返回至 Placed。",
	"warehouse_receive_num": "",
	"warehouse_zone_id": "",
	"warehousebin_id": "",
	"warning": "警告",
	"wechat": "微信",
	"Wed": "周三",
	"wed_route": "周三路线",
	"wed_stop": "周三停靠点",
	"Weekly": "周",
	"weeks_left_after_1_week": "一周后剩馀周数",
	"weight": "重量",
	"weight_lbs": "重量 (磅)",
	"service": "服务",
	"tracking_link": "追踪链接",
	"weight(s)_cannot_have_a_zero_value": "",
	"weight_range": "重量范围",
	"weight_return": "退货重量",
	"wh": "WH",
	"wholesale": "批发",
	"wholesale_only": "仅限批发",
	"wk_sale": "周销售",
	"work_not_saved_warning": "您的工作还未保存！您确定你要退出？",
	"working_order": "工作顺序",
	"working_orders": "转换库存",
	"year": "年",
	"yes": "是",
	"yesterday": "昨天",
	"your_order": "您的订单",
	"your_purchase_order": "采购订单",
	"your_purchase_quote": "采购报价",
	"your_purchase_template": "采购模板",
	"your_return_order": "您的采购退货单",
	"your_sales_order": "您的销售订单",
	"your_so_no_period_is": "销售单号是",
	"zip": "邮编",
	"zipcode": "邮政编码",
	"zone": "区域",
	"zone_description": "",
	"zone_detail": "",
	"zone_detail_view": "",
	"zone_id": "区域 ID",
	"zone_level": "区域等级",
	"zone_name": "区域名称",
	"zone_no": "区域编号",
	"create_ap": "Create AP",
	"create_ar": "Create AR",
	"new_working_orders": "新转换库存",
	"ref_sales": "销售参考价",
	"price_style_1": "原价",
	"price_style_2": "价格尾数0,5,9",
	"color": "颜色",
	"brand": "品牌",
	"style": "款式",
	"us_size": "美国尺寸",
	"eu_size": "欧洲尺寸",
	"repair_detail": "维修明细",
	"shipping_detail": "邮寄信息",
	"Customer_Name": "客户姓名",
	"Customer_Mobile": "客户电话",
	"Customer_Address": "客户地址",
	"Customer_Email": "电子邮箱地址",
	"customer_link": "绑定客户",
	"rma": "退货授权",
	"RMA_Content": "提单内容简介",
	"RMA_Service_Type": "服务类型",
	"RMA_Number": "RMA号码",
	"Product_Serial_Number": "产品序列号",
	"Product_Description": "产品描述",
	"Is_Urgent": "加急?",
	"Is_Warranty": "保修?",
	"Return_Logistics_Company": "物流公司",
	"Return_Tracking_Number": "物流跟踪号吗",
	"Openbox_Description": "开箱检查",
	"Product_Detail_Info": "产品详细信息",
	"Warehouse_Check_Info": "仓库检查信息",
	"Status": "状态",
	"Repair_Note": "维修注释",
	"Dispatch_Logistics_Company": "物流公司",
	"Dispatch_Tracking_Number": "物流公司跟踪号码",
	"Shipping_Cost": "物流费用",
	"Dispatch_Description": "物流描述",
	"Product_Model": "产品型号",
	"unreceived": "未收到",
	"repairing": "维修中",
	"repaired": "已维修",
	"dispatched": "已派送",
	"excel_qb": "Quick Book导出",
	"delivery_tracking_num": "跟踪号码",
	"total_delivery_fee": "邮寄费用",
	"shippingMethod": "送货方式",
	"quality": "质量描述",
	"pos_holds": "保留单",
	"pos_holds_full_table": "POS 保留列表",
	"Shipping_fee": "运费",
	"Misc_fee": "杂费",
	"arrival_price": "到货价",
	"main_sku": "主要的SKU",
	"admin_password": "管理员密码",
	"admin": "管理员",
	"sales_popularity": "产品活跃",
	"confirmNcontinue": "确定并继续",
	"weight_not_in_range": "其中一个或者多个产品的重量不在定义的产品重量范围内",
	"add_credit_amount": "添加/减去积分",
	"edit_credit": "编辑积分",
	"business_user": "商业用户",
	"Business_already_verified": "已验证",
	"business_name": "商业名称",
	"full_name": "代表人全名",
	"phone_number": "电话号码",
	"confirm_verification": "验证此用户",
	"verified": "验证状态",
	"Name_and_Description_fields_are_required": "名称和产品描述为必填项",
	"passcode_confirm_text": "输入passcode确认身份",
	"category_description": "类别描述",
	"meta_description": "元描述",
	"meta_title": "元题目",
	"meta_keywords": "元关键字",
	"key": "关键字",
	"category_info_edit": "编辑类别信息",
	"category_display_info": "类别显示讯息",
	"category_meta_info": "类别元数据",
	"VPN": "VPN",
	"business_type": "商业类型",
	"ssn": "社会安全号",
	"is_retailer": "零售商",
	"year_in_business": "创立年份",
	"all_locations": "全部地点",
	"alcohol": "酒精",
	"platform": "平台",
	"customer_discount": "折扣(%OFF)",
	"discount_$": "折扣 $",
	"discount_rate_%": "折扣率 %",
	"generating": "生成中...",
	"outbound_order": "出口单",
	"outbound_order2": "XPO订单列表",
	"inbound_order": "入库单",
	"storage_orders": "仓库单",
	"inventory_history": "仓库历史",
	"checking": "检测中",
	"rma_num": "RMA号码",
	"return_tracking": "退货跟踪号码",
	"proccess_status": "维修状态",
	"request_type": "请求类型",
	"sn_num": "SN号码",
	"notes_shortcut": "快捷附注",
	"products_repaired": "需要维修的产品",
	"products_cost": "维修消耗的产品",
	"notes": "附注",
	"request_details": "客户备注",
	"sku_num": "SKU号码",
	"appointment": "預約",
	"lowest_sale": "最低售价",
	"dollarsign": "",
	"pre_order": "Pre Orders",
	"ship_to_orders": "Ship To Orders",
	"ship_from_orders": "Ship From Orders",
	"other_service": "Other Service",
	"type_in_credit": "Type In Credit",
	"credit_details": "Credit Details",
	"mobile_user_messages_management": "Mobile User Messages management",
	"mobile_user_products": "Mobile User Products",
	"lot_number": "仓位",
	"legend_inventory_stop_sale": "停售",
	"legend_inventory_danger_stock": "库存 < 最低范围",
	"legend_inventory_warning_stock": "最低范围 ≤ 库存 ≤ 最大范围",
	"legend_inventory_over_stock": "库存 > 最大范围",
	"legend_inventory_po_stock": "库存 + 购买单数量 > 最小范围",
	"legend_inventory_half_stock": "库存 < 最低范围 ÷ 2",
	"picking_list": "拣货单",
	"packing_list": "装箱单",
	"shipping_list": "运输单",
	"creator": "创建者",
	"show_image": "图片展示",
	"invoice_creator": "发票创建者",
	"no_payment_record": "没有支付记录",
	"box_qty": "数量",
	"upload_product": "上传产品",
	"product_template": "产品模板"
};


//////////////////
// WEBPACK FOOTER
// ./master/i18n/ch.json
// module id = 755
// module chunks = 0